import type { MapString } from '@dhl/mdp-api'
import { DataRow, DataHeading } from '~/modules/ppp/submodules/relations/components/data'

type Props = {
  prefix: string
  properties: MapString
}

export const CommonProperties = ({ prefix, properties }: Props) => (
  <>
    <DataHeading title={`${prefix} properties`} />
    {Object.entries(properties).map(([key, value]) => (
      <DataRow key={key} title={`${prefix} / ${key}`} payload={value} withCopy />
    ))}
  </>
)
